"use client";
import styled from "../../../client-utils/styled/index.js";
import shouldForwardPropUtil from "../../../client-utils/styled/shouldForwardProp.util.js";
import { DOUBLE, QUATTUORDECUPLE } from "../../../constants/numbers.consts.js";
import { NAVIGATION_RAIL_DRAWERWIDTH, NAVIGATION_RAIL_SUB_DRAWERWIDTH } from "../../../constants/navigationRail.consts.js";
// import classes
import { paperClasses } from "@mui/material/Paper";
// import components
import Drawer from "@mui/material/Drawer";
const coreComponentName = "SdbDrawer";
const shouldForwardProp = shouldForwardPropUtil("clipped", "expanded", "roundedCorners");
export const SdbDrawer = styled(Drawer, {
    shouldForwardProp,
    name: coreComponentName,
    slot: "Root",
})(({ theme, roundedCorners }) => {
    const leftCorners = roundedCorners === "left" ? theme.shape.borderRadius : 0;
    const rightCorners = roundedCorners === "right" ? theme.shape.borderRadius : 0;
    return {
        [`& > .${paperClasses.root}`]: {
            borderTopRightRadius: rightCorners,
            borderBottomRightRadius: rightCorners,
            borderTopLeftRadius: leftCorners,
            borderBottomLeftRadius: leftCorners,
        },
    };
});
export const NavigationRail = styled(Drawer, {
    shouldForwardProp,
    name: coreComponentName,
    slot: "NavigationRail",
})(({ theme, clipped, expanded }) => ({
    [`& > .${paperClasses.root}`]: {
        overflow: "hidden",
        backgroundColor: theme.palette.background.default,
        border: "solid thin transparent",
        transition: theme.transitions.create([
            "width",
            "border-top-right-radius",
            "border-bottom-right-radius",
            "border",
            "box-shadow",
        ]),
        display: "flex",
        flexDirection: "row",
        boxSizing: "border-box",
        boxShadow: theme.shadows[expanded ? DOUBLE : 0],
        ...theme.applyStyles("dark", {
            background: theme.vars.palette.AppBar.defaultBg,
        }),
        ...(expanded
            ? {
                width: NAVIGATION_RAIL_DRAWERWIDTH + NAVIGATION_RAIL_SUB_DRAWERWIDTH,
                borderTopRightRadius: theme.shape.borderRadius,
                borderBottomRightRadius: theme.shape.borderRadius,
            }
            : { width: NAVIGATION_RAIL_DRAWERWIDTH }),
        ...(clipped
            ? { height: `calc(100% - ${theme.mixins.toolbar.minHeight})`, top: theme.spacing(QUATTUORDECUPLE) }
            : {}),
    },
}));
